export const selectDropdownStyles = {
  dropdown: {
    width: 'max-content !important',
    minWidth: '100%',
    maxWidth: 'none',
  },
  item: {
    whiteSpace: 'nowrap',
  },
} as const;
